import { useState, type FormEvent } from 'react'
import { Link,useNavigate,useLocation } from 'react-router-dom'
import axios from 'axios'
import {apiClient,apiOrigin,normalizeApiError} from '../../lib/apiClient'
import {useAuth} from './AuthContext'

export default function RegisterPage(){
 const navigate=useNavigate(),location=useLocation();const auth=useAuth();const [busy,setBusy]=useState(false),[error,setError]=useState('')

 async function submit(e:FormEvent<HTMLFormElement>){
  e.preventDefault();setBusy(true);setError('')
  const values=Object.fromEntries(new FormData(e.currentTarget))
  try{
   await axios.get(apiOrigin+'/sanctum/csrf-cookie',{withCredentials:true,withXSRFToken:true})
   await apiClient.post('/auth/register',{...values,consent:true})
   await auth.login(String(values.email||values.mobile),String(values.password))
   const from=(location.state as {from?:string}|null)?.from
   navigate(from?.startsWith('/patient/')?from:'/patient/dashboard')
  }catch(err){
   const detail=normalizeApiError(err)
   setError(Object.values(detail.validation).flat().join(' ')||detail.message)
  }finally{
   setBusy(false)
  }
 }

 return (
  <div className="auth-card p-4" style={{maxWidth:'850px',width:'100%'}}>
   <div className="text-center mb-3">
    <h1 className="h3 mb-1">Create your patient account</h1>
    <p className="text-muted small mb-0">Enter your information to create an account</p>
   </div>

   <form onSubmit={submit}>
    <div className="row g-2">
     {[
      ['name','Full name','text'],
      ['email','Email','email'],
      ['mobile','Mobile','tel'],
      ['date_of_birth','Date of birth','date'],
      ['address','Address','text'],
      ['emergency_contact_name','Emergency contact','text'],
      ['emergency_contact_mobile','Emergency mobile','tel'],
      ['password','Password','password'],
      ['password_confirmation','Confirm password','password']
     ].map(([name,label,type])=>
      <div className="col-md-6" key={name}>
       <label className="form-label small mb-1">{label}</label>
       <input
        className="form-control form-control-sm"
        name={name}
        type={type}
        required={['name','mobile','password','password_confirmation'].includes(name)}
        minLength={type==='password'?8:undefined}
       />
      </div>
     )}

     <div className="col-md-6">
      <label className="form-label small mb-1">Gender</label>
      <select className="form-select form-select-sm" name="gender">
       <option value="">Prefer not to specify</option>
       <option value="female">Female</option>
       <option value="male">Male</option>
       <option value="other">Other</option>
      </select>
     </div>
    </div>

    <div className="form-check mt-3 mb-2">
     <input className="form-check-input" type="checkbox" id="consent" required/>
     <label className="form-check-label small" htmlFor="consent">
      I consent to storing my information for care and appointment management.
     </label>
    </div>

    {error&&<div role="alert" className="alert alert-danger py-2 small mb-2">{error}</div>}

    <button className="btn btn-primary w-100 py-2" disabled={busy}>
     {busy?'Creating account…':'Register'}
    </button>

    <p className="text-center small mt-2 mb-0">
     <Link to="/login" state={location.state}>Already registered? Log in</Link>
    </p>
   </form>
  </div>
 )
}